module.exports = __webpack_public_path__ + "img/loading.038994c7.svg";